import script from "./infoUser.vue?vue&type=script&setup=true&lang=js"
export * from "./infoUser.vue?vue&type=script&setup=true&lang=js"

import "./infoUser.vue?vue&type=style&index=0&id=639fd4e7&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639fd4e7"]])

export default __exports__